<div class="category-menu text-body-medium only-web">

  <button type="button" class="category-menu__name btn" (click)="toggleShowMenu()">
    <ng-icon name="heroTag" size="24"></ng-icon>
    <span>Catálogo</span>
    <ng-icon name="heroChevronDown" size="16"></ng-icon>
  </button>

  <div class="category-menu__opts" *ngIf="isMenuOpened && ((categories$ | async)?.length || 0) > 0">
    <atm-category-card *ngFor="let category of categories$ | async" [category]="category" (click)="close()"/>
  </div>

</div>